const GraphHelpMenu = () => (
    <ul className="help-menu" data-testid="help-menu">
        <li>
            <span className="shortcut">Ctrl</span>+<span className="shortcut">H</span>: Open & close
            help
        </li>
        <li>
            <span className="shortcut">Ctrl</span>+<span className="shortcut">C</span>: Copy a step
        </li>
        <li>
            <span className="shortcut">Ctrl</span>+<span className="shortcut">V</span>: Paste a step
        </li>
        <li>
            <span className="shortcut">Ctrl</span>+<span className="shortcut">F</span>: Open search
            menu
        </li>
        <li>
            <span className="shortcut">Dot (.)</span>: Open canvas settings
        </li>
        <li>
            <span className="shortcut">Ctrl</span>+<span className="shortcut">G</span>: Group
            selected steps
        </li>
        <li>
            <span className="shortcut">Ctrl</span>+<span className="shortcut">Shift</span>+
            <span className="shortcut">G</span>: Ungroup selected group step
        </li>
        <li>
            <span className="shortcut">Shift</span>+<span className="shortcut">A</span>: Auto
            arrange graph
        </li>
        <li>
            <span className="shortcut">Shift</span>+<span className="shortcut">F</span>: Zoom to fit
            graph
        </li>
        <li>
            <span className="shortcut">Mouse Scroll</span> or{' '}
            <span className="shortcut">Plus (+)</span> and{' '}
            <span className="shortcut">Minus (-)</span>: Zoom graph in/out
        </li>
        <li>
            <span className="shortcut">Left Mouse</span> or <span className="shortcut">Enter</span>:
            Select a step/outcome
        </li>
        <li>
            <span className="shortcut">Left Mouse</span>+<span className="shortcut">Drag</span> or{' '}
            <span className="shortcut">Arrow keys</span>: Move selected step or pan graph
        </li>
        <li>
            <span className="shortcut">Shift</span>+<span className="shortcut">Arrow keys</span>:
            Move selected step faster (speed scales with zoom level)
        </li>
        <li>
            <span className="shortcut">Alt</span>+<span className="shortcut">Left Mouse</span> or{' '}
            <span className="shortcut">L</span>: Highlight directly connected steps
        </li>
        <li>
            <span className="shortcut">Ctrl</span>+<span className="shortcut">Left Mouse</span> or{' '}
            <span className="shortcut">Enter</span>: Add a selected step to multi-selection
        </li>
        <li>
            <span className="shortcut">Double Click</span> or{' '}
            <span className="shortcut">Space</span>: Edit a step
        </li>
        <li>
            <span className="shortcut">Right Mouse</span> or{' '}
            <span className="shortcut">≣ Menu</span>: Open context menu
        </li>
        <li>
            <span className="shortcut">Right Mouse</span>+<span className="shortcut">Drag</span>:
            Select all steps within dragged region
        </li>
        <li>
            <span className="shortcut">Escape</span>: Close all menus/Deselect all steps
        </li>
        <li>
            <span className="shortcut">Delete</span>: Delete selected step/outcome
        </li>
    </ul>
);

export default GraphHelpMenu;
